import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckCircle2Icon } from 'lucide-react';
export function ProductHero() {
  const categories = ['U10/U12', 'U13/U15', 'U17/U19', 'Físico', 'Táctica', 'Gestión'];
  return <section className="py-20 px-4 bg-dark-DEFAULT border-t border-dark-border" data-id="element-230">
      <div className="max-w-5xl mx-auto text-center" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-232">
          <div className="inline-flex items-center space-x-2 bg-dark-card border border-dark-border px-4 py-2 rounded-full" data-id="element-233">
            <StarIcon size={16} className="text-brand-gold fill-brand-gold" data-id="element-234" />
            <span className="text-sm font-bold tracking-wider text-brand-gold uppercase" data-id="element-235">
              Sistema N°1 para Entrenadores de Vóley
            </span>
          </div>

          <h2 className="text-5xl md:text-7xl font-bebas flex flex-col" data-id="element-236">
            <span className="text-white" data-id="element-237">EDULABS</span>
            <span className="text-brand-DEFAULT" data-id="element-238">MegaPack Voley Listo</span>
          </h2>

          <p className="text-2xl md:text-3xl font-bebas tracking-wide" data-id="element-239">
            <span className="text-white" data-id="element-240">6 Tomos + 6 Bonos — </span>
            <span className="text-brand-DEFAULT" data-id="element-241">
              Todos los niveles — Todo resuelto.
            </span>
          </p>

          <p className="text-lg md:text-xl text-brand-gold max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-242">
            +300 páginas · 150 sesiones modelo · 101 drills pro
          </p>

          <div className="flex flex-wrap justify-center gap-3 pt-6" data-id="element-243">
            {categories.map((cat, index) => <div key={index} className="flex items-center space-x-2 bg-brand-DEFAULT/15 border-2 border-brand-DEFAULT/60 px-5 py-3 rounded-lg" data-id="element-244">
                <CheckCircle2Icon size={18} className="text-brand-DEFAULT" data-id="element-245" />
                <span className="text-white font-bold" data-id="element-246">{cat}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}